import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useMemo } from 'react';

export default function useSuggestionsDogsData(currentDogId) {
    const { firestore } = useFirebaseProviders();
    const [data, loading, error] = useCollection(
        firestore.collection('dogs').where('isForSale', '==', true),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
            idField: 'id',
        }
    );

    const filteredData = useMemo(() => {
        if (!data) return {};
        return {
            ...data,
            docs: data?.docs.filter(doc => doc.id !== currentDogId),
        };
    }, [currentDogId, data]);

    return [filteredData, loading, error];
}
